/**
 * Global re-consent (B5c) Axios response handler.
 *
 * Detects the canonical stale-consent response — HTTP 409 with
 * { status: 'reconsent_required', redirect: '...' } — from ANY endpoint
 * (a web-page AJAX call, the login endpoint, or an API call) and redirects
 * the browser there. The error is tagged (isReconsentRequired) and
 * rejected normally so local .catch() handlers can detect it and skip
 * showing a misleading error message.
 */
export function isReconsentRequiredError(error) {
    const res = error?.response;

    return res?.status === 409 && res?.data?.status === 'reconsent_required';
}

export function installReconsentInterceptor(axiosInstance, locationRef = window.location) {
    return axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (isReconsentRequiredError(error)) {
                error.isReconsentRequired = true;
                if (locationRef.pathname !== '/re-consent') {
                    locationRef.href = error.response.data.redirect;
                }
            }

            return Promise.reject(error);
        }
    );
}
